export default "__VITE_ASSET__DgfhnXcT__"